import { isNull, get } from "lodash"
import locales from "./../../../content.json";

import coffee from './img/coffee.png'
import horns from './img/horns.png'
import ok from './img/ok.png'
import two from './img/two.png'

export const checkIsValidCurrentActivity = data => {
    return validateCurrentStep(get(data, ["water", "value"], "")) && !data.water.isValid
}

export const validateCurrentStep = value => {
    return !isNull(value)
}

export const staticData = {
    0: {
        value: "0",
        title: locales[window.userLang].water_step_1,
        icon: coffee,
    },
    1: {
        value: "1",
        title: locales[window.userLang].water_step_2,
        icon: two,
    },
    2: {
        value: "2",
        title: locales[window.userLang].water_step_3,
        icon: ok,
    },
    3: {
        value: "3",
        title: locales[window.userLang].water_step_4,
        icon: horns,
    },
}